import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import Intro from "../presentational/Intro";
import Header from "../presentational/Header";
import { images } from "../images/";
import { getRandomInt } from "../functions/getRandomInt";

class HeaderContainer extends PureComponent {
  wasAnimated = false;
  timeToWait = 20000;

  // на всеки рефреш се взема рандъм индекс на картинка,
  // която се използва за фон
  state = {
    bgIndex: getRandomInt(0, images.length - 1)
  };

  // функцията анимира background картинката
  // на всеки 20 секунди зарежда нова такава
  // след която я слага за фон
  toggleBgImage = () => {
    setTimeout(() => {
      const bgIndex = this.state.bgIndex === images.length - 1 ? 0 : this.state.bgIndex + 1;
      const img = new Image();
      img.src = images[bgIndex][0];
      img.onload = () => {
        this.setState({ bgIndex });
        this.toggleBgImage();
      };
    }, this.timeToWait);
  };

  componentDidMount() {
    this.wasAnimated = true;
    this.toggleBgImage();
  }

  render() {
    const { pathname } = this.props.location;

    // isLarge - дали сме на началната страница, за да покажем
    // по-голям хедъра (с по-голяма височина)
    const isLarge = pathname === "/za-nas" || pathname === "/";
    const animation = this.wasAnimated ? "transitioned-fade-in-slow" : "transitioned-move-up";
    const style = images[this.state.bgIndex];
    return (
      <Header isLarge={isLarge} backgroundImage={style[0]} backgroundPosition={style[1]}>
        {isLarge && <Intro animation={animation} />}
      </Header>
    );
  }
}

export default withRouter(HeaderContainer);



// WEBPACK FOOTER //
// ./src/containers/Header.js